<template>
    <div>
        <bCardRecordHeader :param="params" @on-click-number="getAccountNumberChange"></bCardRecordHeader>

        <div class="trade-recordes">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                    <div class="title">{{$t('tradeRecords.'+accountType)}}: {{number}}</div>
                </el-col>
            </el-row>

            <el-row :gutter="10">
                <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
                    <el-input class="hidden-md-and-down" style="width:100%;" placeholder="交易单号" prefix-icon="el-icon-document" v-model="orderNumber">
                        <el-button slot="append" @click="searchTranId(orderNumber)">{{$t('tradeRecords.search')}}</el-button>
                    </el-input>
                    <el-input class="hidden-lg-and-up" style="width: 220px;" placeholder="交易单号" prefix-icon="el-icon-document" v-model="orderNumber">
                        <el-button slot="append" @click="searchTranId(orderNumber)">{{$t('tradeRecords.search')}}</el-button>
                    </el-input>
                </el-col>

                <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="4">
                    <el-date-picker class="hidden-md-and-down" style="width:100%;" v-model="startDate" @change="getStartDate"
                    format="yyyy-MM-dd" type="date" placeholder="START"></el-date-picker>
                    <el-date-picker class="hidden-lg-and-up mt" v-model="startDate" @change="getStartDate" format="yyyy-MM-dd"
                    type="date" placeholder="START"></el-date-picker>
                </el-col>

                <el-col :xs="24" :sm="24" :md="24" :lg="6" :xl="4">
                    <el-date-picker class="hidden-md-and-down" style="width:100%;" v-model="endDate" @change="getEndDate" format="yyyy-MM-dd"
                    type="date" placeholder="END"></el-date-picker>
                    <el-date-picker class="hidden-lg-and-up mt" v-model="endDate" @change="getEndDate" format="yyyy-MM-dd"
                    type="date" placeholder="END"></el-date-picker>
                </el-col>

                <el-col :xs="24" :sm="24" :md="24" :lg="3" :xl="2">
                    <el-button class="hidden-md-and-down" @click="exportExcel" type="primary">{{$t('tradeRecords.export')}}</el-button>
                    <el-button class="hidden-lg-and-up mt" @click="exportExcel" type="primary">{{$t('tradeRecords.export')}}</el-button>
                </el-col>
            </el-row>

            <!-- 数据加载处理   -->
            <div v-if="loading" style="height:500px;">
                <div class="spinner">
                    <div class="bounce1"></div>
                    <div class="bounce2"></div>
                    <div class="bounce3"></div>
                </div>
            </div>
            <div v-else-if="!tableData.length" style="height:500px;">
            <el-card class="table-box-card" style="height:300px;">
                <img :src="src" alt="noRecord" width="40" height="40"><br>
                <span class="no-data">{{$t('tradeRecords.noData')}}</span>
            </el-card>
            </div>
            <div v-else class="table-box">
                <!-- 表格 -->
                <el-table element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" stripe :data="tableData" :highlight-current-row="true" style="width: 100%;" height="550" tooltip-effect="dark" cell-mouse-enter="mouseEnterCall">
                    <el-table-column v-for="(item, key) in cols" :key="key" :prop="item.name == 'bs_flag' ? getKey(item.name) : item.name" :label="item.label" sortable>
                      <template slot-scope="scope">{{item.name == 'bs_flag' ? getKey(scope.row[item.name]) : scope.row[item.name]}}</template>
                    </el-table-column>
                </el-table>
                <!-- 分页 -->
                <el-pagination class="hidden-md-and-down" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[3, 5, 10, 15]" :pager-count="5" :page-size="pageSize" layout="sizes, prev, pager, next, jumper" :total="total"></el-pagination>
                <el-pagination class="hidden-lg-and-up my-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[3, 5, 10, 15]" :pager-count="5" :page-size="pageSize" layout="prev, pager, next" :total="total"></el-pagination>

            </div>

        </div>

    </div>
</template>
<script>
import _ from 'lodash'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      params: {
        title: 'trade_recordes',
        links: [
          { title: 'home' },
          { title: 'trade_recordes' }
        ]
      },
      tableData: [],
      initialData: [],
      number: '', // 交易账号
      accountType: '', // 交易账号类型
      orderNumber: '', // 交易单号（搜索用）
      startDate: new Date((new Date()).getTime() - 3600 * 1000 * 24 * 30),
      endDate: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1),
      currentPage: 1, // 当前页码
      total: 0, // 总页数
      pageSize: 15, // 每页条目数
      offset: '0', // 从第几条开始查
      loading: true,
      src: require('@/assets/images/noTradeRecordsIcon.jpg')
    }
  },
  computed: {
    ...mapGetters(['getUser', 'valueAccountNumber', 'accountNumbers']),
    // 表格标题
    cols () {
      return [
        { label: this.$t('tradeRecords.clientAccount'), name: 'client_acc_id', type: 'normal', exportwidth: '20' },
        { label: this.$t('tradeRecords.transDate'), name: 'tran_date', type: 'normal', exportwidth: '20' },
        { label: this.$t('tradeRecords.valueDate'), name: 'value_date', type: 'normal', exportwidth: '20' },
        { label: this.$t('tradeRecords.transId'), name: 'tran_id', type: 'normal', exportwidth: '20' },
        { label: this.$t('tradeRecords.productName'), name: 'product_id', type: 'normal', exportwidth: '20' },
        { label: this.$t('tradeRecords.number'), name: 'qty', type: 'normal', exportwidth: '20' },
        { label: this.$t('tradeRecords.tranAmount'), name: 'gc', type: 'normal', exportwidth: '20' },
        { label: this.$t('tradeRecords.commission'), name: 'comm', type: 'normal', exportwidth: '20' },
        { label: this.$t('tradeRecords.market'), name: 'market_id', type: 'normal', exportwidth: '20' },
        { label: this.$t('tradeRecords.orderType'), name: 'bs_flag', type: 'normal', exportwidth: '20' },
        { label: this.$t('tradeRecords.avgPrice'), name: 'avg_price', type: 'normal', exportwidth: '20' }
      ]
    }
  },
  mounted () {
    if (this.valueAccountNumber) {
      this.number = this.valueAccountNumber
    }
    // if (this.accountNumbers) {
    if (this.$store.getters.valueAccountNumber) {
      this.accountType = this.getAccountType(this.accountNumbers, this.number)
      this.getAccountNumberChange(this.$store.getters.valueAccountNumber)
    }
  },
  methods: {
    // 订单类型翻译
    getKey (key) {
      var item = this.$t('tradeRecords')
      var str = key.substring(0, 1)
      return item[str] ? item[str] : key
    },
    formatter (row, column) {
      return row.address
    },
    mouseEnterCall (row, column, cell, event) {
      console.log(row, column, cell, event)
    },
    async getAccountNumberChange (val) {
      this.currentPage = 1
      this.number = val
      this.accountType = this.getAccountType(this.accountNumbers, this.number)
      let options = {
        tradeAccount: this.valueAccountNumber,
        searchKey: '',
        searchVal: '',
        limit: this.pageSize,
        offset: '0',
        startTime: moment(this.startDate).format('YYYY-MM-DD'),
        endTime: moment(this.endDate).format('YYYY-MM-DD'),
        orderValue: 'value_date',
        order: 'desc'
      }
      await this.getTransactionRecords(this.accountType.toLowerCase(), options)
    },
    // 获取交易账户类型
    getAccountType (arr, obj) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].value === obj) {
          return arr[i].label
        }
      }
      return '--'
    },
    // 开始时间
    async getStartDate (val) {
      this.startDate = val
      if (!this.startDate) {
        return this.openMessage('error', this.$t('tradeRecords.selectStartTime'))
      }
      if (!this.endDate) {
        return this.openMessage('error', this.$t('tradeRecords.selectEndTime'))
      }
      if (new Date(this.endDate) < new Date(this.startDate)) {
        return this.openMessage('error', this.$t('tradeRecords.selectTimeError'))
      }
      this.$emit('search-fun', [this.startDate, this.endDate])
      // 接口
      let options = {
        tradeAccount: this.valueAccountNumber,
        searchKey: '',
        searchVal: '',
        limit: this.pageSize,
        offset: '0',
        startTime: moment(this.startDate).format('YYYY-MM-DD'),
        endTime: moment(this.endDate).format('YYYY-MM-DD'),
        orderValue: 'value_date',
        order: 'desc'
      }
      await this.getTransactionRecords(this.accountType.toLowerCase(), options)
    },
    // 结束时间
    async getEndDate (val) {
      if (!this.startDate) {
        this.endDate = ''
        return this.openMessage('error', this.$t('tradeRecords.selectStartTime'))
      }
      if (!this.endDate) {
        return this.openMessage('error', this.$t('tradeRecords.selectEndTime'))
      }
      this.endDate = new Date(new Date(new Date(this.endDate).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
      if (new Date(this.endDate) < new Date(this.startDate)) {
        return this.openMessage('error', this.$t('tradeRecords.selectTimeError'))
      }
      this.endDate = val
      this.endDate = new Date(new Date(new Date(this.endDate).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
      this.$emit('search-fun', [this.startDate, this.endDate])
      // 接口
      let options = {
        tradeAccount: this.valueAccountNumber,
        searchKey: '',
        searchVal: '',
        limit: this.pageSize,
        offset: '0',
        startTime: moment(this.startDate).format('YYYY-MM-DD'),
        endTime: moment(this.endDate).format('YYYY-MM-DD'),
        orderValue: 'value_date',
        order: 'desc'
      }
      await this.getTransactionRecords(this.accountType.toLowerCase(), options)
    },
    // 导出
    async exportExcel () {
      let typeOpt = {
        stock: 'ayers',
        futures: 'esunny'
      }
      let urlType = typeOpt[this.accountType.toLowerCase()]
      if (!urlType) {
        this.initialData = 0
        return
      }
      let result = await this.$transactionServiceApi.getTransactionRecords(urlType, {
        tradeAccount: this.valueAccountNumber,
        searchKey: this.orderNumber !== '' ? 'tran_id' : '',
        searchVal: this.orderNumber,
        limit: '',
        offset: '0',
        startTime: moment(this.startDate).format('YYYY-MM-DD'),
        endTime: moment(this.endDate).format('YYYY-MM-DD'),
        orderValue: 'value_date',
        order: 'desc'
      })
      this.initialData = result.data.rows
      // 导出数据报表xlsx文件，已注入所有Vue实例，template模板里调用 $$outputXlsxFile，组件方法里调用 this.$outputXlsxFile
      // 例：this.$outputXlsxFile([['字段1', '字段2'], [1, 2]], [{wch: 10}, {wch: 50}], '测试导出') 得到 测试导出.xlsx 文件
      // 第一个参数是导出的数组对象，第二个参数是设置字段宽度，第三个参数是文件名
      var exportDataTest = []
      // 获取字段宽度
      var getWidthArr = this.cols.map(function (obj) {
        let tempArr = {}
        tempArr['wch'] = obj.exportwidth
        return tempArr
      })
      // 获取导出数据标题
      var getNameArr = this.cols.map(function (obj) {
        let tempArr = []
        tempArr = obj.label
        return tempArr
      })
      exportDataTest.push(getNameArr)
      // 获取导出数据内容
      for (var g = 0; g < this.initialData.length; g++) {
        var testArr = []
        for (var h = 0; h < this.cols.length; h++) {
          // 订单类型翻译判断
          if (this.cols[h].name === 'bs_flag') {
            var str = this.initialData[g][this.cols[h].name].substring(0, 1)
            testArr.push(this.$t('tradeRecords.' + str))
          } else {
            testArr.push(this.initialData[g][this.cols[h].name])
          }
        }
        exportDataTest.push(testArr)
      }
      this.$outputXlsxFile(exportDataTest, getWidthArr, 'tradeRecordesExcel')
    },
    // 分页方法
    async getPageData (obj) {
      if (new Date(this.endDate) < new Date(this.startDate)) {
        return this.openMessage('error', this.$t('tradeRecords.selectTimeError'))
      }

      let offset = Number(obj.currentPage - 1) * obj.pageSize
      this.currentPage = offset === 0 ? 1 : this.currentPage
      let options = {
        tradeAccount: this.valueAccountNumber,
        searchKey: '',
        searchVal: '',
        limit: obj.pageSize,
        offset: offset === 0 ? '0' : offset,
        startTime: moment(this.startDate).format('YYYY-MM-DD'),
        endTime: moment(this.endDate).format('YYYY-MM-DD'),
        orderValue: 'value_date',
        order: 'desc'
      }
      await this.getTransactionRecords(this.accountType.toLowerCase(), options)
    },
    // 分页：pageSize 改变时会触发
    handleSizeChange (val) {
      this.pageSize = val
      var obj = {}
      obj.pageSize = val
      obj.currentPage = 1
      this.getPageData(obj)
    },
    // 分页：currentPage 改变时会触发
    handleCurrentChange (val) {
      this.currentPage = val
      var obj = {}
      obj.pageSize = this.pageSize
      obj.currentPage = val
      this.getPageData(obj)
    },
    async searchTranId (num) {
      let options = {
        tradeAccount: this.number,
        searchKey: 'tran_id',
        searchVal: num,
        limit: this.pageSize,
        offset: '0',
        startTime: moment(this.startDate).format('YYYY-MM-DD'),
        endTime: moment(this.endDate).format('YYYY-MM-DD'),
        orderValue: 'value_date',
        order: 'desc'
      }
      await this.getTransactionRecords(this.accountType.toLowerCase(), options)
    },
    // 接口方法
    async getTransactionRecords (type, options) {
      let typeOpt = {
        stock: 'ayers',
        futures: 'esunny'
      }
      let urlType = typeOpt[type]
      if (!urlType) {
        this.total = 0
        this.tableData = 0
        return
      }
      this.loading = true
      let result = await this.$transactionServiceApi.getTransactionRecords(urlType, {
        tradeAccount: options.tradeAccount, // 交易账户
        searchKey: options.searchKey, // 搜索字段名
        searchVal: options.searchVal, // 搜索字段值
        limit: options.limit, // 每页条目数
        offset: options.offset, // 从第几条数据开始查起
        startTime: options.startTime, // 交易日期
        endTime: options.endTime, // 结算日期
        orderValue: options.orderValue, // 排序字段名
        order: options.order // 升序或降序
      })
      this.loading = false
      this.total = result.data.count
      this.tableData = result.data.rows
    }
  }
}
</script>
<style lang="scss">
  .trade-recordes{
    margin-top: 10px;
    padding: 20px;
    background: #fff;
    border-radius: 5px;
    webkit-box-shadow: 0 3px 6px 0 rgba(40, 40, 90, 0.09), 0 1px 1px 0 rgba(0, 0, 0, 0.065);
    box-shadow: 0 3px 6px 0 rgba(40, 40, 90, 0.09), 0 1px 1px 0 rgba(0, 0, 0, 0.065);
    .mt{ margin-top: 10px;}
    .title{
        font-size: 22px;
        font-weight: bold;
    }
    .el-row{ margin-bottom: 20px;}
    .el-input-group__append button.el-button{
      background: #fec000;
      color: #0f2c52;
    }
    .el-button--primary{
      background: #0f2c52;
      color: #fff;
      border: 1px solid #0f2c52;
      margin-left: 0;
    }
    .table-box-card{
        text-align: center;
        padding-top: 200px;
    }
    .el-pagination__sizes{
      .el-input__inner{
        color:  #fec000 !important;
        font-weight: 300;
      }
    }
    .el-card{ border:0;}
    .no-data {
      font-family: PingFangTC-Regular;
      font-size: 12px;
      color: #7d7d7d;
      letter-spacing: -0.19px;
      margin-top: 16px;
    }
    .spinner {
      margin: 100px auto 0;
      width: 150px;
      text-align: center;
    }
    .spinner > div {
      width: 30px;
      height: 30px;
      background-color: #fec000;
      border-radius: 100%;
      display: inline-block;
      -webkit-animation: bouncedelay 1.4s infinite ease-in-out;
      animation: bouncedelay 1.4s infinite ease-in-out;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
    }
    .spinner .bounce1 {
      -webkit-animation-delay: -0.32s;
      animation-delay: -0.32s;
    }
    .spinner .bounce2 {
      -webkit-animation-delay: -0.16s;
      animation-delay: -0.16s;
    }
    .table-box { overflow: auto;}
    @-webkit-keyframes bouncedelay {
    0%, 80%, 100% { -webkit-transform: scale(0.0) }
    40% { -webkit-transform: scale(1.0) }
    }
    @keyframes bouncedelay {
      0%, 80%, 100% {
        transform: scale(0.0);
        -webkit-transform: scale(0.0);
      } 40% {
        transform: scale(1.0);
        -webkit-transform: scale(1.0);
      }
    }
    .el-pagination{ margin-top:20px;}
    .el-table__row {
      height: 20px;
      &:hover {
        background: #fff !important;
      }
    }
    th {
      font-size: 12px;
      font-family: "Muli-Bold";
      color: #0f2c52;
    }
    .el-table__row--striped {
      background-color: #f3f4f6;
      td { background-color: transparent !important;}
    }
    .my-pagination{
      text-align: center;
      .el-pager li{ min-width: auto;}
      button{ padding: 0;}
      .btn-prev{ padding-right: 0;}
      .btn-next{ padding-left: 0;}
    }
  }
  @media (max-width: 768px){
    .layout-container .container .view {
      max-width: 100%;
      padding: 0;
      margin: 0;
    }
  }
</style>
